import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PaymentInstallment } from 'src/app/entities/payment-installment';
import { BaseTableComponent } from 'src/app/pages/base-table/base-table.component';
import { PaymentInstallmentService } from 'src/app/services/payment-installment.service';
import { AlertService } from 'src/app/services/alert.service';
import { MatTableModule } from '@angular/material/table';
import { CartItem } from 'src/app/entities/cart-item';
import { Product } from 'src/app/entities/product';

@Component({
  selector: 'app-view-mount-card',
  templateUrl: './view-mount-card.component.html',
  styleUrls: ['./view-mount-card.component.scss'],
})

export class PaymentInstallmentComponent extends BaseTableComponent<PaymentInstallment> implements OnInit {
  
  cart = new Array<CartItem>();
  product = new Product();
  price = 0;

  displayedColumns = ['type', 'title', 'id', 'percent'];
  configColumns = [
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'type',
      field_key: 'type',
      type: 'option',
      title: 'Tipo',
      classes: '',
      options: {
        '0': {
          title: 'Visa / MasterCard / Cabal'
        },
        '1': {
          title: 'MutualCard'
        },
      }
    },
    {
      key: 'id',
      field_key: 'id',
      type: 'string',
      title: 'Precio por Cuota',
      classes: '',
    },
    {
      key: 'percent',
      field_key: 'percent',
      type: 'string',
      title: 'Total',
      classes: ''
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<PaymentInstallmentComponent>,
    protected installmentService: PaymentInstallmentService,
    protected alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(alertService);
    this.service = installmentService;
  }

  closeDialog(): void{
    this.dialogRef.close();
  }

  getPrice() {
    return Product.getPrice(this.data.product);
  }

  ngOnInit(): void {
    this.price = parseFloat(String(this.getPrice()));
    this.loadItems(this.price);
    
    // Initialize Feather icons
    setTimeout(() => {
      if (typeof (window as any).feather !== 'undefined') {
        (window as any).feather.replace();
      }
    }, 0);
  }

  formatPrice(value: string): string {
    // The values come as "$299420.94", we just need to format with dots for thousands and comma for decimals
    const cleanValue = value.replace('$', '').trim();
    const numValue = parseFloat(cleanValue);
    
    // Always format with 2 decimals to keep consistency
    return '$' + numValue.toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  formatCuotas(value: string): string {
    // Remove leading zeros and get the number
    // "01 Cuota" -> "1", "03 Cuota" -> "3", "12 cuota" -> "12"
    const match = value.match(/\d+/);
    if (!match) return value;
    
    const num = parseInt(match[0]);
    
    // Pluralize: 1 Cuota, 2+ Cuotas
    return num === 1 ? `${num} Cuota` : `${num} Cuotas`;
  }

}
